import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'
import { useTranslation } from 'react-i18next'

import { Text, VStack } from '@enechain/ecloud-designsystem'

import { convertAreaLabel } from '~/models/area'
import type { DraftSubmitSplit } from '~/pages/SpotBidding/models/draftSubmitPlan'

/**
 * 承認の要否が違う札が混ざる提出の内訳 (AC-BSP-015、 design `spot.html` の #8804)。
 * 承認申請する札とそのまま提出する札の件数・エリアを 1 行ずつ出す。 確認モーダルの注記 (`note`)
 * の本文に渡す。
 */
export const DraftSubmitSplitNote = ({
  split,
}: {
  split: DraftSubmitSplit
}): React.ReactElement => {
  const { t } = useTranslation()
  const areasOf = (areaCodes: readonly AreaCode[]): string =>
    areaCodes
      .map((area) => convertAreaLabel(area))
      .join(t('page:biddingCommon.submitConfirm.items.areaSeparator'))

  return (
    <VStack align="stretch" gap={1}>
      <Text>
        ・
        <Text as="span" fontWeight="bold">
          {t('page:biddingSpot.approvalAction.mixedSplitRequestLabel')}
        </Text>
        {t('page:biddingSpot.approvalAction.mixedSplitRequestDetail', {
          areas: areasOf(split.request.areaCodes),
          count: split.request.count,
        })}
      </Text>
      <Text>
        ・
        <Text as="span" fontWeight="bold">
          {t('page:biddingSpot.approvalAction.mixedSplitSubmitLabel')}
        </Text>
        {t('page:biddingSpot.approvalAction.mixedSplitSubmitDetail', {
          areas: areasOf(split.submit.areaCodes),
          count: split.submit.count,
        })}
      </Text>
    </VStack>
  )
}
